import ConnectedTicketModal from './connected_ticket_modal';
import TicketModal from './ticket_modal';

export { TicketModal };
export default ConnectedTicketModal;
